module.exports = __webpack_public_path__ + "placa_td_loja_s_entr_s_juros.png?b422e69075a01d7456bd9f013d0e5e49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_td_loja_s_entr_s_juros.png
// module id = 131
// module chunks = 0